export default "__VITE_ASSET__CbGFdEpY__"